import { render, staticRenderFns } from "./DemoTreeviewHoverable.vue?vue&type=template&id=f8308000&"
import script from "./DemoTreeviewHoverable.vue?vue&type=script&lang=js&"
export * from "./DemoTreeviewHoverable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../landing-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../landing-app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VTreeview})
